export default "__VITE_ASSET__VTKeAQlv__"